import React, { useEffect, useRef, useState } from 'react';
import * as BABYLON from '@babylonjs/core';
import '@babylonjs/loaders';
import { useMachine } from '@xstate/react';
import { catrineMachine } from '../machine/CatrineMachine';

/*
Liste des animations :
[Log] 0 : ac-Crouch To Stand (bundle.js, line 401)
[Log] 1 : ac-Crouch To Stand.001 (bundle.js, line 401)
[Log] 2 : ac-Crouching (bundle.js, line 401)
[Log] 3 : ac-Football Hike (bundle.js, line 401)
[Log] 4 : ac-Grenade Throw (bundle.js, line 401)
[Log] 5 : ac-Gunplay (bundle.js, line 401)
[Log] 6 : ac-Holding Down (bundle.js, line 401)
[Log] 7 : ac-Kneeling (bundle.js, line 401)
[Log] 8 : ac-Kneeling Idle (bundle.js, line 401)
[Log] 9 : ac-Military Signaling (bundle.js, line 401)
[Log] 10 : ac-Standing Up (bundle.js, line 401)
[Log] 11 : al-Getting Up (bundle.js, line 401)
[Log] 12 : al-Getting Up 2 (bundle.js, line 401)
[Log] 13 : al-Getting Up 2.001 (bundle.js, line 401)
[Log] 14 : al-Getting Up 2.002 (bundle.js, line 401)
[Log] 15 : al-Kicking Out (bundle.js, line 401)
[Log] 16 : al-Laying (bundle.js, line 401)
[Log] 17 : al-Laying Idle (bundle.js, line 401)
[Log] 18 : al-Laying Idle.001 (bundle.js, line 401)
[Log] 19 : al-Laying.001 (bundle.js, line 401)
[Log] 20 : al-Sitting Idle (bundle.js, line 401)
[Log] 21 : al-Sitting Idle 2 (bundle.js, line 401)
[Log] 22 : al-Sitting Idle 2.001 (bundle.js, line 401)
[Log] 23 : al-Sitting Idle.001 (bundle.js, line 401)
[Log] 24 : al-Stand Up (bundle.js, line 401)
[Log] 25 : al-Stand Up.001 (bundle.js, line 401)
[Log] 26 : al-Standing Up (bundle.js, line 401)
[Log] 27 : al-Standing Up.001 (bundle.js, line 401)
[Log] 28 : al-Start Bicycle Sit Up (bundle.js, line 401)
[Log] 29 : al-Start Bicycle Sit Up.001 (bundle.js, line 401)
[Log] 30 : al-Stunned (bundle.js, line 401)
[Log] 31 : al-Zombie Stand Up (bundle.js, line 401)
[Log] 32 : al-Zombie Stand Up 2 (bundle.js, line 401)
[Log] 33 : as-Beckoning (bundle.js, line 401)
[Log] 34 : as-Playing Drums (bundle.js, line 401)
[Log] 35 : as-Pointing (bundle.js, line 401)
[Log] 36 : as-Seated Idle (bundle.js, line 401)
[Log] 37 : as-Sitting (bundle.js, line 401)
[Log] 38 : as-Sitting 2 (bundle.js, line 401)
[Log] 39 : as-Sitting And Pointing (bundle.js, line 401)
[Log] 40 : as-Sitting Angry (bundle.js, line 401)
[Log] 41 : as-Sitting Clap (bundle.js, line 401)
[Log] 42 : as-Sitting Clap 3 (bundle.js, line 401)
[Log] 43 : as-Sitting Disapproval (bundle.js, line 401)
[Log] 44 : as-Sitting Disapproval 2 (bundle.js, line 401)
[Log] 45 : as-Sitting Laughing (bundle.js, line 401)
[Log] 46 : as-Sitting Rubbing Arm (bundle.js, line 401)
[Log] 47 : as-Sitting Talking (bundle.js, line 401)
[Log] 48 : as-Sitting Thumbs Up (bundle.js, line 401)
[Log] 49 : as-Sitting Yell (bundle.js, line 401)
[Log] 50 : as-Stand To Sit (bundle.js, line 401)
[Log] 51 : as-Stand Up (bundle.js, line 401)
[Log] 52 : as-Standing Clap (bundle.js, line 401)
[Log] 53 : at-Acknowledging (bundle.js, line 401)
[Log] 54 : at-Agreeing (bundle.js, line 401)
[Log] 55 : at-Angry (bundle.js, line 401)
[Log] 56 : at-Angry Gesture (bundle.js, line 401)
[Log] 57 : at-Angry Point (bundle.js, line 401)
[Log] 58 : at-Annoyed Head Shake (bundle.js, line 401)
[Log] 59 : at-Arm Gesture (bundle.js, line 401)
[Log] 60 : at-Bored (bundle.js, line 401)
[Log] 61 : at-Breathing Idle (bundle.js, line 401)
[Log] 62 : at-Button Pushing (bundle.js, line 401)
[Log] 63 : at-Charge (bundle.js, line 401)
[Log] 64 : at-Cheering (bundle.js, line 401)
[Log] 65 : at-Clapping (bundle.js, line 401)
[Log] 66 : at-Cross Jumps (bundle.js, line 401)
[Log] 67 : at-Defeat (bundle.js, line 401)
[Log] 68 : at-Defeat 2 (bundle.js, line 401)
[Log] 69 : at-Defeated (bundle.js, line 401)
[Log] 70 : at-Defeated copie (bundle.js, line 401)
[Log] 71 : at-Dismissing Gesture (bundle.js, line 401)
[Log] 72 : at-Dismissing Gesture 2 (bundle.js, line 401)
[Log] 73 : at-Drunk Idle Variation (bundle.js, line 401)
[Log] 74 : at-Dwarf Idle (bundle.js, line 401)
[Log] 75 : at-Dwarf Idle 2 (bundle.js, line 401)
[Log] 76 : at-Fist Pump (bundle.js, line 401)
[Log] 77 : at-Gathering Objects (bundle.js, line 401)
[Log] 78 : at-Hand Raising (bundle.js, line 401)
[Log] 79 : at-Hands Forward Gesture (bundle.js, line 401)
[Log] 80 : at-Hands Forward Gesture.001 (bundle.js, line 401)
[Log] 81 : at-Happy (bundle.js, line 401)
[Log] 82 : at-Happy Idle (bundle.js, line 401)
[Log] 83 : at-Happy Idle 2 (bundle.js, line 401)
[Log] 84 : at-Head Gesture (bundle.js, line 401)
[Log] 85 : at-Idle (bundle.js, line 401)
[Log] 86 : at-Idle 2 (bundle.js, line 401)
[Log] 87 : at-Idle 3 (bundle.js, line 401)
[Log] 88 : at-Kiss (bundle.js, line 401)
[Log] 89 : at-Laughing (bundle.js, line 401)
[Log] 90 : at-Lengthy Head Nod (bundle.js, line 401)
[Log] 91 : at-Listening To Music (bundle.js, line 401)
[Log] 92 : at-Look Around (bundle.js, line 401)
[Log] 93 : at-Look Around 2 (bundle.js, line 401)
[Log] 94 : at-Look Away Gesture (bundle.js, line 401)
[Log] 95 : at-Look Over Shoulder (bundle.js, line 401)
[Log] 96 : at-Looking (bundle.js, line 401)
[Log] 97 : at-Looking 2 (bundle.js, line 401)
[Log] 98 : at-Loser (bundle.js, line 401)
[Log] 99 : at-Loser.001 (bundle.js, line 401)
[Log] 100 : at-No (bundle.js, line 401)
[Log] 101 : at-Orc Idle (bundle.js, line 401)
[Log] 102 : at-Petting Animal (bundle.js, line 401)
[Log] 103 : at-Pointing Forward (bundle.js, line 401)
[Log] 104 : at-Pouting (bundle.js, line 401)
[Log] 105 : at-Quick Formal Bow (bundle.js, line 401)
[Log] 106 : at-Quick Formal Bow.001 (bundle.js, line 401)
[Log] 107 : at-Roar (bundle.js, line 401)
[Log] 108 : at-Salute (bundle.js, line 401)
[Log] 109 : at-Sarcastic Head Nod (bundle.js, line 401)
[Log] 110 : at-Searching Pockets (bundle.js, line 401)
[Log] 111 : at-Shake Fist (bundle.js, line 401)
[Log] 112 : at-Shoulder Rubbing (bundle.js, line 401)
[Log] 113 : at-Shrugging (bundle.js, line 401)
[Log] 114 : at-Standing 2H Magic Attack 01 (bundle.js, line 401)
[Log] 115 : at-Standing Arguing (bundle.js, line 401)
[Log] 116 : at-Standing Arguing 2 (bundle.js, line 401)
[Log] 117 : at-Standing Arguing 3 (bundle.js, line 401)
[Log] 118 : at-Standing Idle 03 (bundle.js, line 401)
[Log] 119 : at-Standing Jump (bundle.js, line 401)
[Log] 120 : at-Standing Jump.001 (bundle.js, line 401)
[Log] 121 : at-Standing Torch Light Torch (bundle.js, line 401)
[Log] 122 : at-Standing W_Briefcase Idle (bundle.js, line 401)
[Log] 123 : at-Talking (bundle.js, line 401)
[Log] 124 : at-Talking 2 (bundle.js, line 401)
[Log] 125 : at-Talking 3 (bundle.js, line 401)
[Log] 126 : at-Talking On Phone (bundle.js, line 401)
[Log] 127 : at-Unarmed Idle 01 (bundle.js, line 401)
[Log] 128 : at-Waving (bundle.js, line 401)
[Log] 129 : at-Weight Shift (bundle.js, line 401)
[Log] 130 : at-Whatever Gesture (bundle.js, line 401)
[Log] 131 : at-Yawn (bundle.js, line 401)
[Log] 132 : at-Yawn.001 (bundle.js, line 401)
[Log] 133 : at-Yawn.002 (bundle.js, line 401)
[Log] 134 : ba-Arm Stretching (bundle.js, line 401)
[Log] 135 : ba-Arm Stretching.001 (bundle.js, line 401)
[Log] 136 : ba-Big Side Hit (bundle.js, line 401)
[Log] 137 : ba-Body Block (bundle.js, line 401)
[Log] 138 : ba-Boxing (bundle.js, line 401)
[Log] 139 : ba-Center Block (bundle.js, line 401)
[Log] 140 : ba-Cross Jumps Rotation (bundle.js, line 401)
[Log] 141 : ba-Dodging Right (bundle.js, line 401)
[Log] 142 : ba-Fight Idle (bundle.js, line 401)
[Log] 143 : ba-Fighting Idle (bundle.js, line 401)
[Log] 144 : ba-Head Hit (bundle.js, line 401)
[Log] 145 : ba-Hook (bundle.js, line 401)
[Log] 146 : ba-Idle (bundle.js, line 401)
[Log] 147 : ba-Idle 2 (bundle.js, line 401)
[Log] 148 : ba-Idle.001 (bundle.js, line 401)
[Log] 149 : ba-Illegal Knee (bundle.js, line 401)
[Log] 150 : ba-Jab Cross (bundle.js, line 401)
[Log] 151 : ba-Jump (bundle.js, line 401)
[Log] 152 : ba-Kicking (bundle.js, line 401)
[Log] 153 : ba-Kicking.001 (bundle.js, line 401)
[Log] 154 : ba-Lead Jab (bundle.js, line 401)
[Log] 155 : ba-Left Block (bundle.js, line 401)
[Log] 156 : ba-Light Hit To Head (bundle.js, line 401)
[Log] 157 : ba-Livershot Knockdown (bundle.js, line 401)
[Log] 158 : ba-Martelo 2 (bundle.js, line 401)
[Log] 159 : ba-Medium Hit To Head (bundle.js, line 401)
[Log] 160 : ba-Mma Kick (bundle.js, line 401)
[Log] 161 : ba-Mma Kick 2 (bundle.js, line 401)
[Log] 162 : ba-Mma Kick 3 (bundle.js, line 401)
[Log] 163 : ba-Nervously Look Around (bundle.js, line 401)
[Log] 164 : ba-Ninja Idle (bundle.js, line 401)
[Log] 165 : ba-Ninja Idle 2 (bundle.js, line 401)
[Log] 166 : ba-Pontera (bundle.js, line 401)
[Log] 167 : ba-Punching (bundle.js, line 401)
[Log] 168 : ba-Reaction (bundle.js, line 401)
[Log] 169 : ba-Restrain (bundle.js, line 401)
[Log] 170 : ba-Stabbing (bundle.js, line 401)
[Log] 171 : ba-Standing 1H Cast Spell (bundle.js, line 401)
[Log] 172 : ba-Standing Death Backward (bundle.js, line 401)
[Log] 173 : ba-Stomp (bundle.js, line 401)
[Log] 174 : ba-Taking Punch (bundle.js, line 401)
[Log] 175 : ba-Taking Punch.001 (bundle.js, line 401)
[Log] 176 : ba-Thrust Slash (bundle.js, line 401)
[Log] 177 : ba-Two Hand Spell Casting (bundle.js, line 401)
[Log] 178 : ba-Zombie Punching (bundle.js, line 401)
[Log] 179 : da-Bboy Hip Hop Move (bundle.js, line 401)
[Log] 180 : da-Belly Dance (bundle.js, line 401)
[Log] 181 : da-Bellydancing (bundle.js, line 401)
[Log] 182 : da-Breakdance Freeze Var 2 (bundle.js, line 401)
[Log] 183 : da-Breakdance Uprock Var 1 (bundle.js, line 401)
[Log] 184 : da-Breakdance Uprock Var 2 (bundle.js, line 401)
[Log] 185 : da-Chicken Dance (bundle.js, line 401)
[Log] 186 : da-Dancing Twerk (bundle.js, line 401)
[Log] 187 : da-Excited (bundle.js, line 401)
[Log] 188 : da-Gangnam Style (bundle.js, line 401)
[Log] 189 : da-Hip Hop Dancing (bundle.js, line 401)
[Log] 190 : da-Hip Hop Dancing 2 (bundle.js, line 401)
[Log] 191 : da-Hip Hop Dancing 3 (bundle.js, line 401)
[Log] 192 : da-Hip Hop Dancing copie (bundle.js, line 401)
[Log] 193 : da-Hip Hop Dancing copie 2 (bundle.js, line 401)
[Log] 194 : da-House Dancing (bundle.js, line 401)
[Log] 195 : da-Jazz Dancing (bundle.js, line 401)
[Log] 196 : da-Jazz Dancing 2 (bundle.js, line 401)
[Log] 197 : da-Joyful Jump (bundle.js, line 401)
[Log] 198 : da-Northern Soul Spin (bundle.js, line 401)
[Log] 199 : da-Northern Soul Spin Combo (bundle.js, line 401)
[Log] 200 : da-Robot Hip Hop Dance (bundle.js, line 401)
[Log] 201 : da-Rumba Dancing (bundle.js, line 401)
[Log] 202 : da-Salsa Dancing (bundle.js, line 401)
[Log] 203 : da-Salsa Dancing 2 (bundle.js, line 401)
[Log] 204 : da-Salsa Dancing 4 (bundle.js, line 401)
[Log] 205 : da-Samba Dancing (bundle.js, line 401)
[Log] 206 : da-Samba Dancing 2 (bundle.js, line 401)
[Log] 207 : da-Silly Dancing (bundle.js, line 401)
[Log] 208 : da-Swing Dancing (bundle.js, line 401)
[Log] 209 : da-Swing Dancing 2 (bundle.js, line 401)
[Log] 210 : da-Tut Hip Hop Dance (bundle.js, line 401)
[Log] 211 : da-Twist Dance (bundle.js, line 401)
[Log] 212 : da-Wave Hip Hop Dance (bundle.js, line 401)
[Log] 213 : ma-Catwalk Walking (bundle.js, line 401)
[Log] 214 : ma-Drunk Walk (bundle.js, line 401)
[Log] 215 : ma-Holding Walk (bundle.js, line 401)
[Log] 216 : ma-Jogging (bundle.js, line 401)
[Log] 217 : ma-Reloading (bundle.js, line 401)
[Log] 218 : ma-Run Look Back (bundle.js, line 401)
[Log] 219 : ma-Standard Walk (bundle.js, line 401)
[Log] 220 : ma-Strut Walking (bundle.js, line 401)
[Log] 221 : ma-Texting And Walking (bundle.js, line 401)
[Log] 222 : ma-Walk (bundle.js, line 401)
[Log] 223 : ma-Walk 2 (bundle.js, line 401)
*/

const BabylonScene = () => {

  // Référence au Canvas
  const canvasRef = useRef(null);

  // Initialisation de la State Machine
  const [stateAnim, sendEvent] = useMachine(catrineMachine)

  // Numéro de l'animation de départ
  const numAnimDepart = 114

  // Etats des objets BabylonJS
  const [scene, setScene] = useState(null);
  const [currentAnimation, setCurrentAnimation] = useState(numAnimDepart);
  const [animations, setAnimations] = useState([]);
  const [currentFrame, setCurrentFrame] = useState(0);
  const [totalFrames, setTotalFrames] = useState(0);

  const [transitionEnCours, setTransitionEnCours] = useState('Pas de transition');

  // Durée en frames de la transition
  const mix = 50

  // Probabilité de changer de catégorie
  const probaCategorie = 0.2

  // Liste des catégories
  const listeCategories = ["attente", "accroupie", "assise", "allongee", "marche", "bagarre", "dance"]

  // useEffect principal, avec boucle BabylonJS
  useEffect(() => {
    const canvas = canvasRef.current;
    const engine = new BABYLON.Engine(canvas, true);

    const createScene = () => {
      const scene = new BABYLON.Scene(engine);

      // Définir la couleur de fond de la scène en blanc
      scene.clearColor = new BABYLON.Color4(1, 1, 1, 1);

      // Création de la caméra
      const camera = new BABYLON.ArcRotateCamera("camera", 1, 1, 2.5, new BABYLON.Vector3(0, 0, 1), scene);
      camera.attachControl(canvas, true);
      camera.inputs.attached.mousewheel.detachControl();
      camera.inputs.attached.pointers.pinchPrecision = 0;

      // Création d'une lumière omnidirectionnelle
      const pointLight = new BABYLON.PointLight("pointLight", new BABYLON.Vector3(-1, 0, 1), scene);
      pointLight.diffuse = new BABYLON.Color3(1, 1, 1);
      pointLight.specular = new BABYLON.Color3(1, 0, 0);
      pointLight.intensity = 10;

      // Création d'une deuxième lumière omnidirectionnelle
      const pointLight1 = new BABYLON.PointLight("pointLight1", new BABYLON.Vector3(1, 1, 1), scene);
      pointLight1.diffuse = new BABYLON.Color3(1, 1, 1);
      pointLight1.specular = new BABYLON.Color3(1, 1, 1);
      pointLight1.intensity = 4;

      // Création d'une lumière hémisphérique
      const hemisphericLight = new BABYLON.HemisphericLight("hemisphericLight", new BABYLON.Vector3(0, 1, 0), scene);
      hemisphericLight.intensity = 0.7;

      camera.target = new BABYLON.Vector3(0, 1, 0);

      // Chargement du modèle
      BABYLON.SceneLoader.ImportMesh('', '', 'AllAnim.glb',
        scene, (meshes, particleSystems, skeletons, animationGroups) => {
          // Sauvegarde des animations
          setAnimations(animationGroups);

          // Lancement de la première animation, et actualisation de la frame courante
          if (animationGroups.length > 0) {
            const animGroup = animationGroups[numAnimDepart];
            animGroup.start(true);
            setTotalFrames(Math.round(animGroup.to - animGroup.from + 1));
            scene.onBeforeRenderObservable.add(() => {
              setCurrentFrame(Math.round(animGroup.animatables[numAnimDepart].masterFrame));
            });
          }
        }
      );
      return scene;
    };

    const scene = createScene();
    setScene(scene);

    engine.runRenderLoop(() => {
      if (scene) {
        scene.render();
      }
    });

    window.addEventListener('resize', () => {
      engine.resize();
    });

    return () => {
      engine.dispose();
    };

  }, []); // fin du useEffect principal avec boucle BabylonJS

  // Joue un son aleatoire
  function son() {
    const nomSon = "./sounds/button-" + String(Math.floor(Math.random() * 11) + 10) + ".mp3";
    let audio = new Audio(nomSon);
    audio.play()
  }

  // Détecte le click sur le personnage
  scene?.meshes.forEach((mesh) => {
    mesh.actionManager = new BABYLON.ActionManager(scene);
    mesh.actionManager.registerAction(new BABYLON.ExecuteCodeAction(
      BABYLON.ActionManager.OnPickTrigger,
      () => {
        son()
        console.log("click")
        if (transitionEnCours != "TRANSITION") {
          enchaineAnims(currentAnimation, animStateMachine(), 2);
          nextAnimation();
        }
      }
    ));
  });

  // Provisoire : info sur le poid des animations en cours
  function checkAnim() {
    console.log("Animation sate machine : " + animStateMachine())
    for (var i = 0; i < scene.animationGroups.length; i++) {
      if (scene.animationGroups[i].animatables[0] != undefined) {
        console.log(i + " - weigth : " + scene.animationGroups[i].animatables[0].weight)
      }
    }
  }

  // Renvoie l'animation sélectionnée dans state machine
  function animStateMachine() {
    var nouvAnim = ""
    if (stateAnim.value == "attente") { nouvAnim = stateAnim.children.attente.getSnapshot().value.replace(/900/g, '.00') }
    if (stateAnim.value == "accroupie") { nouvAnim = stateAnim.children.accroupie.getSnapshot().value.replace(/900/g, '.00') }
    if (stateAnim.value == "assise") { nouvAnim = stateAnim.children.assise.getSnapshot().value.replace(/900/g, '.00') }
    if (stateAnim.value == "allongee") { nouvAnim = stateAnim.children.allongee.getSnapshot().value.replace(/900/g, '.00') }
    if (stateAnim.value == "marche") { nouvAnim = stateAnim.children.marche.getSnapshot().value.replace(/900/g, '.00') }
    if (stateAnim.value == "bagarre") { nouvAnim = stateAnim.children.bagarre.getSnapshot().value.replace(/900/g, '.00') }
    if (stateAnim.value == "dance") { nouvAnim = stateAnim.children.dance.getSnapshot().value.replace(/900/g, '.00') }
    // console.log("Catégorie " + stateAnim.value + " / " + numAnim(nouvAnim) + " : " + nouvAnim)
    return numAnim(nouvAnim)
  };

  // Change aléatoirement de catégorie
  const nextCategorie = () => {
    console.log("Categorie suivante")
    const valeurCat = listeCategories[Math.floor(Math.random() * 7)]
    const eventCat = "switch " + valeurCat
    console.log("Dans changeCat :")
    sendEvent({ type: eventCat })
  }

  // Détecte le changement de catégorie
  useEffect(() => {
    if (scene != null) {
      console.log("Changement de catégorie : " + stateAnim.value)
      if (transitionEnCours != "TRANSITION") {
        enchaineAnims(currentAnimation, animStateMachine(), 2);
        nextAnimation();
      }
    }
  }, [stateAnim.value]);

  // Change d'animation dans une catégorie
  const nextAnimation = () => {
    console.log("Animation suivante")
    if (stateAnim.value == "attente") { stateAnim.children.attente.send({ type: "NEXT01" }) }
    if (stateAnim.value == "accroupie") { stateAnim.children.accroupie.send({ type: "NEXT01" }) }
    if (stateAnim.value == "assise") { stateAnim.children.assise.send({ type: "NEXT01" }) }
    if (stateAnim.value == "allongee") { stateAnim.children.allongee.send({ type: "NEXT01" }) }
    if (stateAnim.value == "marche") { stateAnim.children.marche.send({ type: "NEXT01" }) }
    if (stateAnim.value == "bagarre") { stateAnim.children.bagarre.send({ type: "NEXT01" }) }
    if (stateAnim.value == "dance") { stateAnim.children.dance.send({ type: "NEXT01" }) }
  }

  const animSuivante = () => {
    console.log("Animation suivante clic")
    if (transitionEnCours != "TRANSITION") {
      enchaineAnims(currentAnimation, animStateMachine(), 2);
      nextAnimation();
    }
  }

  // Enchaine deux animations avec transition
  const enchaineAnims = (A1, A2, duration) => {
    console.log("Transition de " + A1 + " vers " + A2 + " sur durée " + duration)
    setTransitionEnCours("TRANSITION")
    if (animations.length > 0) {
      const currentAnim = animations[A1];
      const nextAnim = animations[A2];
      nextAnim.start(true);
      setTotalFrames(Math.round(nextAnim.to - nextAnim.from + 1));
      // Fait décroitre progressivement le poids de l'animation courante, et croitre l'animation suivante
      let blendingFactor = 0;
      const blendingDuration = 2.0; // Durée de la transition en secondes
      const blendingInterval = 16; // Intervalle en milisecondes (6 ms = 60 fps)
      const blendingStep = () => {
        blendingFactor += blendingInterval / (blendingDuration * 500);
        if (blendingFactor >= 1) {
          currentAnim.stop();
          nextAnim.setWeightForAllAnimatables(1);
          console.log("Fin de transition")
          setTransitionEnCours("Pas de transition")
          setCurrentAnimation(A2);
        } else {
          currentAnim.setWeightForAllAnimatables(1 - blendingFactor);
          nextAnim.setWeightForAllAnimatables(blendingFactor);
          setTimeout(blendingStep, blendingInterval);
        }
      };
      blendingStep();
      scene.onBeforeRenderObservable.clear();
      scene.onBeforeRenderObservable.add(() => {
        setCurrentFrame(Math.round(nextAnim.animatables[0].masterFrame));
      });
    }
  };

  // Boucle de contrôle des frames
  useEffect(() => {
    if ((currentFrame > totalFrames - mix - 5) && (currentFrame != 0)) {
      if (transitionEnCours != "TRANSITION") {
        console.log("détecte fin de l'anim en cours")
        if (Math.random() > probaCategorie) {
          enchaineAnims(currentAnimation, animStateMachine(), 2);
          nextAnimation();
        } else {
          nextCategorie()
        }
      }
    }
  }, [currentFrame, totalFrames]);

  // Numéro d'une animation selon son libellé
  function numAnim(nomAnim) {
    var numAnim = 0;
    for (var i = 0; i < scene.animationGroups.length; i++) {
      if (nomAnim == scene.animationGroups[i].name) numAnim = i
    }
    return numAnim
  }

  return (

      <canvas ref={canvasRef} style={{ width: '100%', height: '100%' }} />

  );
};

export default BabylonScene;
